import React from 'react'
import Button from './Button'

const CreateCustomerFormExpanded = ({OnCancel}) => {

    const handleSubmit = (event) => {
        // Handle form submission logic
        event.preventDefault();
        console.log('Form submitted');
      };


  return (
    <form action="" className='create-customer-form-expanded flex flex-col gap-10' onSubmit={handleSubmit}> 
        <section className='flex gap-10'>
            <div className='flex flex-col'>
                <label htmlFor="">First name</label>
                <input type="text" placeholder='Enter first name' className='mt-2'/>
            </div>
            <div className='flex flex-col'>
                <label htmlFor="">Last name</label>
                <input type="text" placeholder='Enter last name' className='mt-2' />
            </div>
        </section>

        <section className='flex gap-10'>
            <div className='flex flex-col'>
                <label htmlFor="">Phone number</label>
                <input type="text" placeholder='Enter phone number' className='mt-2'/>
            </div>
            <div className='flex flex-col'>
                <label htmlFor="">Email address</label>
                <input type="text" placeholder='Enter email' className='mt-2'/>
            </div>
        </section>

        <section className=''>
            <div className='flex flex-col'>
                <label htmlFor="">Add customer preferences</label>
                <textarea type="text" placeholder='Enter first name' className='mt-2'/>
            </div>
        </section>

        <section className=''>
            <div className='flex flex-col'>
                <label htmlFor="">Notes</label>
                <textarea type="text" placeholder='Add additional notes' className='mt-2'/>
            </div>
        </section>
        {/* <div className="create-order-divider"></div> */}
        <section className='mt-20 flex gap-20'>
            <Button style={{background: 'none', color: '#434C5A', fontWeight: '400'}} onClick={OnCancel}>Cancel</Button>
            <div className='create-customer-btn'>
                <Button>Create Customer</Button>
            </div>
            
        </section>
    </form>
  )
}

export default CreateCustomerFormExpanded